<template>
  <div id="app">
    <notifications group="alert" position="bottom right" :duration="1000"></notifications>
    <base-layout />
  </div>
</template>

<script>
import BaseLayout from '@/layouts/BaseLayout'

export default {
  name: 'App',
  components: {BaseLayout}
}
</script>
<style lang="scss"></style>
